import React from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { Container } from 'src/elements'
import { glossariesRoute } from '../../consts'
import { Breadcrumbs } from 'src/components/Breadcrumbs'
import { LastNewArticles } from '../NewsArticleDetails/components/LastNewsArticles'
import {
  useGlossaryIndex,
  useNewsArticles,
  useGlossaryReadAlso,
} from 'src/state'
import { ReadAlso } from './components/ReadAlso'
import { WEBSITE } from 'src/consts'

export type GlossaryDetailsProps = {
  slug: string
}
export const GlossaryDetails = ({ slug }: GlossaryDetailsProps) => {
  const { title, shortPreview, content } = useGlossaryIndex({ slug }).data
  const readAlsoData = useGlossaryReadAlso().data
  const lastNewsArticles = useNewsArticles({
    page: 1,
    pageSize: 5,
  }).data?.data

  const glossarieBreadrumbs = [
    { breadcrumb: 'Crypto Glossary', href: glossariesRoute() },
  ]

  return (
    <div className={styles.container}>
      <Container className={styles.glossarieContainer}>
        <div className={styles.leftColumn}>
          <div className={styles.header}>
            <Breadcrumbs
              items={glossarieBreadrumbs}
              lastItem={title}
              wrapperClassName={styles.breadcrumbs}
            />
            <h1 className={styles.title}>{title}</h1>
          </div>
          <article className={styles.glossaryArticle}>
            <div className={styles.shortDescription}>{shortPreview}</div>
            <div className={styles.longDescription}>
              <div
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </div>
          </article>
        </div>
        <div className={styles.rightSidebar}>
          {lastNewsArticles && (
            <div className={styles.rightColumn}>
              <LastNewArticles
                className={styles.lastNewsArticles}
                newsArticles={lastNewsArticles}
              />
            </div>
          )}
        </div>
      </Container>
      {readAlsoData && (
        <div className={styles.readAlso}>
          <ReadAlso data={readAlsoData} />
        </div>
      )}
    </div>
  )
}

const GlossaryDetailsLayout = ({ children, slug }) => {
  const { seo, title } = useGlossaryIndex({ slug }).data
  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: seo?.metaTitle || title,
        description:
          seo?.metaDescription ||
          `Learn what ${title} means in the cryptocurrency space and markets in general`,
        keywords: seo?.keywords,
        robots: seo?.metaRobots,
        canonical: `${WEBSITE}/glossary/${slug}`,
      }}
    >
      {children}
    </BaseLayout>
  )
}

GlossaryDetails.getLayout = GlossaryDetailsLayout
